import React, { FC } from 'react';
import { GetUserFiltered_getUserFiltered as User } from '../../types/schemaTypes';
import { useLazyLoading } from '../_common';
import { Option } from './interface';
import UserItem from './UserItem';
import './Users.scss';

interface UserListProps {
    users: User[];
    refetch?: () => void;
    options: Option[];
    isLoading: boolean;
    canEditUsers: boolean;
    isEndOfResults: boolean;
    onLoadMore: () => void;
    onEditClick: (user: User) => void;
}

const UserList: FC<UserListProps> = ({
    users,
    refetch,
    options,
    isLoading,
    isEndOfResults,
    onLoadMore,
    onEditClick,
    canEditUsers,
}: UserListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('userList', isLoading, isEndOfResults, onLoadMore);

    if (refetch) {
        refetch();
    }

    return (
        <div className="Users-List" onScroll={handleScroll}>
            {users.map((user, index) => (
                <UserItem
                    key={user.id ? user.id.toString() : '0'}
                    index={index}
                    canEditUsers={canEditUsers}
                    user={user}
                    options={options}
                    onEditClick={onEditClick}
                ></UserItem>
            ))}
        </div>
    );
};

export default UserList;

